export enum MailingStatus {
    NOT_SEND = 'NONE',
    SENDING = 'SENDING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
    DISABLE = 'DISABLE'
}

export enum EmailTypes {
    UNKNOWN = 'UNKNOWN',
    REGISTRATION_LINK = 'REGISTRATION_LINK',
    CONFIRMATION_CODE = 'CONFIRMATION_CODE',
    RESET_PASSWORD_LINK = 'RESET_PASSWORD_LINK'
}

export class MailingConfig {
    mailingEnable: boolean;
    whiteLabelId: number;
}

export class MailingRequest {
    emailType: EmailTypes;
    emailData: string;

    constructor(emailType: EmailTypes = EmailTypes.UNKNOWN, emailData: string = '') {
        this.emailType = emailType;
        this.emailData = emailData;
    }
}

export class MailingResponse {
    success: boolean;
    errorMessage: string;
    errors: Array<string>;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/entity/mailing-models.ts